export default class Message {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.closeButton = this.DOM.el.querySelector('.card__toggle-close');
        this.DOM.form = this.DOM.el.querySelector('form');
        this.uuid = this.DOM.el.dataset.newsletterPopup;
        this.uuids = [];

        this.init();
        this.initEvents();
    }

    init() {
        this.uuids = sessionStorage.getItem('closed-newsletter-popups');

        if (this.uuids) {
            this.uuids = JSON.parse(this.uuids);
        } else {
            this.uuids = [];
        }

        const delay = parseInt(this.DOM.el.dataset.newsletterPopupDelay);

        if (!isNaN(delay)) {
            setTimeout(() => {
                if (!this.uuids.includes(this.uuid)) {
                    this.DOM.el.classList.add('ReactModal__Overlay--after-open');
                }
            }, delay * 1000);
        } else {
            if (!this.uuids.includes(this.uuid)) {
                this.DOM.el.classList.add('ReactModal__Overlay--after-open');
            }
        }
    }

    initEvents() {
        /* Close button click event */
        this.DOM.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.closePopup();
        });

        /* Overlay click event */
        this.DOM.el.addEventListener('click', (e) => {
            if (e.target === this.DOM.el) {
                this.closePopup();
            }
        });
    }

    closePopup() {
        this.DOM.el.classList.remove('ReactModal__Overlay--after-open');
        this.uuids.push(this.uuid);
        sessionStorage.setItem("closed-newsletter-popups", JSON.stringify(this.uuids));
    }
}

const messageNodes = Array.from(document.querySelectorAll('[data-newsletter-popup]'));
if (messageNodes !== null) {
    messageNodes.forEach((node) => { new Message(node); });
}
